import { cva } from 'class-variance-authority';

export const tableRowVariants = cva(
    'flex w-full border-b border-grey-100 py-4',
);

export const tbodyVariants = cva(
    'scrollbar block max-h-[268px] overflow-auto',
    {
        variants: {
            overlay: {
                true: 'after:pointer-events-none after:absolute after:bottom-0 after:left-0 after:right-0 after:h-8 after:w-full after:bg-gradient-to-t after:from-white after:to-white/0',
                false: '',
            },
        },
        defaultVariants: {
            overlay: false,
        },
    },
);